import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const GalleryImage = ({ doc, setSelectedImg, index }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    <button
      type="button"
      className="img-wrap"
      onClick={() => setSelectedImg(doc.url)}
      disabled={failed}
      aria-label={`View portfolio photograph ${index + 1}`}
    >
      {!loaded && !failed && (
        <div className="img-loading" role="status" aria-label="Loading image">
          <span className="img-loading-spinner" aria-hidden="true" />
          <span className="sr-only">Loading image</span>
        </div>
      )}
      {failed ? (
        <span className="img-load-error" role="img" aria-label="Image unavailable">
          Image unavailable
        </span>
      ) : (
        <>
          <LazyLoadImage
            src={doc.url}
            effect="blur"
            className="img"
            wrapperClassName="img-wrap__lazy"
            wrapperProps={{
              style: {
                position: 'absolute',
                inset: 0,
                display: 'block',
                width: '100%',
                height: '100%',
              },
            }}
            width={320}
            height={400}
            alt={doc.alt || `Arpita's Makeover portfolio look ${index + 1}`}
            loading="lazy"
            decoding="async"
            threshold={300}
            afterLoad={() => setLoaded(true)}
            onError={() => setFailed(true)}
          />
          <span className="img-wrap__overlay" aria-hidden="true">
            <span className="img-wrap__overlay-label">View photograph</span>
            <span className="img-wrap__expand-badge">
              <svg className="img-wrap__expand-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M8 3H5a2 2 0 0 0-2 2v3m5-5L3 8m13-5h3a2 2 0 0 1 2 2v3m-5-5 5 5m0 8v3a2 2 0 0 1-2 2h-3m5-5-5 5M8 21H5a2 2 0 0 1-2-2v-3m5 5-5-5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </span>
        </>
      )}
    </button>
  );
};

const ImageGrid = ({ setSelectedImg, docs }) => {
  return (
    <div className="portfolio-photo-grid" role="group" aria-label="Portfolio photographs">
      {docs.map((doc, index) => (
        <GalleryImage
          key={doc.id}
          doc={doc}
          index={index}
          setSelectedImg={setSelectedImg}
        />
      ))}
    </div>
  );
};

export default ImageGrid;
